if (!customElements.get('free-shipping-bar')) {
  class FreeShippingBar extends HTMLElement {
    constructor() {
      super();
      this.initialFullValue = +this.getAttribute('data-initial-full-value') || 0;
      this.cartTotalPrice = +this.getAttribute('data-initial-cart-total-price') || 0;
      this.textContainer = this.querySelector('.free-shipping-bar__text-container');
      this.differenceTextElement = this.querySelector('.difference-text');
    }

    connectedCallback() {
      window.addEventListener('go-cart:cart-updated', (event) => {
        this.updateFreeShippingBar(event.detail);
      })
    }

    updateFreeShippingBar(cart) {
      this.cartTotalPrice = cart.total_price;
      const difference = this.initialFullValue - this.cartTotalPrice;
      const differenceText = `$${(difference / 100).toFixed(2)}`;
      this.differenceTextElement.textContent = differenceText;
      this.setAttribute('data-full', difference > 0 ? '' : 'true');
      this.textContainer?.classList.toggle('free-shipping-bar__text-container--hide-fulled', difference > 0);
      this.textContainer?.classList.toggle('free-shipping-bar__text-container--hide-process', difference <= 0);
      this.classList.toggle('free-shipping-bar--hidden', cart.item_count == 0);

      if (difference > 0) {
        const barPercentFilled = (cart.total_price / this.initialFullValue) * 100;
        this.style.setProperty('--filled-percents', `${barPercentFilled}%`);
      } else {
        this.style.setProperty('--filled-percents', '100%');
      }
    }
  }

  customElements.define('free-shipping-bar', FreeShippingBar);
}